import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

/**
 * Ersatzteile -- der Überblick über die Lieferantenbestellungen.
 *
 * WICHTIG: Hier wird NICHT bestellt. Der Einstieg in eine Bestellung liegt ausschließlich im
 * Vorgang; dieses Modul zeigt, was daraus geworden ist, und sammelt die Fälle, bei denen
 * jemand nachfassen muss. Deshalb gibt es hier bewusst keinen Knopf „Neue Bestellung".
 */
export const partsModule: ForqModuleManifest = {
  id: 'parts',
  name: 'Ersatzteile',
  description: 'Lieferantenbestellungen, Klärfälle und Lieferantenanbindung',
  version: '0.1.0',
  route: '/ersatzteile',
  category: 'operations',
  status: 'development',
  requiredPermissions: ['parts.view'],
  features: ['parts.orders', 'parts.review', 'parts.suppliers'],
  navigation: [
    { id: 'parts.primary', label: 'Ersatzteile', route: '/ersatzteile', placement: 'primary', order: 45, icon: 'ersatzteile' },
    { id: 'parts.launcher', label: 'Ersatzteile', route: '/ersatzteile', placement: 'launcher', order: 45, icon: 'ersatzteile' },
  ],
};

export const partsFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'parts.orders',
    moduleId: 'parts',
    name: 'Bestellungen',
    description: 'Alle Ersatzteilbestellungen mit Vorgang, Lieferant, Stand und externer Bestellnummer',
    version: '0.1.0',
    defaultEnabled: true,
    requiredPermissions: ['parts.orders.view_own'],
    uiSlots: [],
    emits: [],
    listensTo: ['tenant.changed', 'parts.order.changed'],
  },
  {
    id: 'parts.review',
    moduleId: 'parts',
    name: 'Klärfälle',
    description: 'Bestellungen mit unklarem oder fehlerhaftem Stand -- nachfassen und entscheiden',
    version: '0.1.0',
    defaultEnabled: true,
    requiredPermissions: ['parts.reconcile'],
    uiSlots: [],
    emits: ['parts.order.changed'],
    listensTo: ['tenant.changed'],
  },
  {
    id: 'parts.suppliers',
    moduleId: 'parts',
    name: 'Lieferantenanbindung',
    description: 'PunchOut und elektronische Bestellung je Lieferant freischalten -- ohne Zugangsdaten',
    version: '0.1.0',
    defaultEnabled: true,
    requiredPermissions: ['parts.admin'],
    uiSlots: [],
    emits: ['parts.connection.changed'],
    listensTo: ['tenant.changed'],
  },
];

/**
 * Die Rechte dieses Bereichs, an einer Stelle.
 *
 * Spiegelt die Einträge, die die Migration in `public.permissions` schreibt -- ein Test hält
 * beide Listen aneinander.
 */
export const partsPermissionKeys: readonly string[] = [
  'parts.view',
  'parts.select',
  'parts.submit',
  'parts.orders.view_own',
  'parts.orders.view_all',
  'parts.admin',
  'parts.reconcile',
  'parts.goods.receive',
];
